import React, { useEffect, useRef, useState } from 'react';
import './ODHomeBestSellers.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getHomePageProductsLoad } from '../../../../actionCreators/home';
import Slider from 'react-slick';
import { v4 } from 'uuid';
import ODProductCardV2 from '../../../../own-days/CommonComponents/ODProductCardV2/ODProductCardV2';
import OdArrowLeftIcon from '../../../../../static/assets/svg/icon-left.svg';
import OdArrowRightIcon from '../../../../../static/assets/svg/icon-right.svg';
import ButtonOwnDays from '../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';

const SLIDES_TO_SHOW = 3;

const ODHomeBestSellers = ({ catId, button, title = '', description = '' }) => {
  const homePageProductsData = useSelector(state => state.home.homePageProducts.data);
  const [slideIndex, setSlideIndex] = useState(0);
  const dispatch = useDispatch();
  const sliderRef = useRef(null);

  const config = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: 1,
    slideIndex,
    centerPadding: '40px',
    afterChange: next => setSlideIndex(next),
    nextArrow: (
      <button aria-label="Click here to see next slide">
        <img alt="right" className="od-best-sellers-slick-icon" src={OdArrowRightIcon} />
      </button>
    ),
    prevArrow: (
      <button aria-label="Click here to see previous slide">
        <img alt="left" className="od-best-sellers-slick-icon" src={OdArrowLeftIcon} />
      </button>
    ),
  };

  useEffect(() => {
    dispatch(getHomePageProductsLoad(catId));
  }, [catId, dispatch]);

  const handleShopBtn = () => {
    // OD__CLEVERTAP__EVENT (cta_click)
    window.location.assign(button.link);
  };

  if (homePageProductsData?.length > 0) {
    return (
      <div className="od-home-bs">
        <div className="od-home-bs__container">
          <div className="od-home-bs__title">{title}</div>
          <div className="od-home-bs__description">{description}</div>
          <Slider ref={sliderRef} {...config}>
            {homePageProductsData.map(product => (
              <div key={v4()}>
                <ODProductCardV2 product={product} theme="v2" />
              </div>
            ))}
          </Slider>
          <div className="od-home-bs__bottom">
            <ButtonOwnDays
              fontClass="od-font-reg"
              fontSize="20px"
              mode="oval-grey"
              px="40px"
              py="12px"
              style={{ margin: '0 auto' }}
              text={button.text}
              onClick={handleShopBtn}
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ODHomeBestSellers;
